const ActionTypes = {}
const ACTION_REDIRECT_TO_LOGIN = 0
const ACTION_CREATE_SP_SESSION = 1

ActionTypes.REDIRECT_TO_LOGIN = ACTION_REDIRECT_TO_LOGIN
ActionTypes.CREATE_SP_SESSION = ACTION_CREATE_SP_SESSION

export default ActionTypes


/** WEBPACK FOOTER **
 ** ./components/utils/action-types.js
 **/